export const getPhoneCallStatusText = ({
  phoneNumber,
  validNumber,
  anotherCallActive,
  localError,
  providerError,
  isCurrentCall,
  status,
  isReady,
  browserCallingSupport,
}) => {
  if (!phoneNumber) return "No phone number on file";
  if (!validNumber) return "Invalid phone number";
  if (browserCallingSupport && !browserCallingSupport.supported) {
    return browserCallingSupport.reason;
  }
  if (anotherCallActive) return "Another call is active";
  if (localError) return localError;
  if (providerError) return providerError;
  if (isCurrentCall) return status === "on-call" ? "On call" : "Call in progress";
  if (!isReady) return "Phone not ready";
  return "Ready to call";
};
